import React from 'react';
import { Button, Dropdown, Menu, Modal, Grid } from 'antd';
import { MoreOutlined, EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PatientCallButton from './PatientCallButton';
import RecordingModal from '../session/RecordingModal';
import { logEvent } from '../../analytics';
import supportedFeature from '../../utils/supportedFeature';
import deletePatient from '../../utils/patient/deletePatient';
import { toast } from 'react-hot-toast';

const { useBreakpoint } = Grid;

const PatientActions = ({ 
  patient, 
  onCallEnded
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const handleDelete = () => {
    Modal.confirm({
      title: t('patient_details.confirm_delete_title'),
      content: t('patient_details.confirm_delete_message'),
      okText: t('patient_details.confirm_delete_ok'),
      okType: 'danger',
      cancelText: t('common.cancel'),
      onOk: async () => {
        try {
          await deletePatient(patient.getUUID());
          logEvent('PatientDetails', 'Delete');
          toast.success(t('patient_details.deleted_success'));
          navigate('/sessions#patients');
        } catch {
          toast.error(t('patient_details.delete_error'));
        }
      },
    });
  };

  const items = [
    {
      key: 'delete',
      danger: true,
      onClick: handleDelete,
      label: t('patient_details.delete')
    }
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: screens.md ? 'flex-start' : 'flex-end',
        marginTop: screens.md ? 0 : 16,
        overflowX: 'auto',
        gap: 8,
        flexWrap: 'nowrap',
        alignItems: 'center',
        minHeight: 40,
      }}
    >
      {supportedFeature('Calls') && (
        <PatientCallButton patient={patient} onCallEnded={onCallEnded} />
      )}
      <RecordingModal patient={patient} fromPatientDetails={true} />
      <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
        <Button icon={<MoreOutlined />} data-testid="patient-hamburger-button" />
      </Dropdown>
    </div>
  );
};

export default PatientActions; 